import { put, call, takeLatest } from "redux-saga/effects";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";

/********** ACTION_TYPES **********/
export const actionTypes = {
  fetchData: "incentivesSummary/INITIATE_FETCH_DATA",
  fetchDataFailed: "incentivesSummary/FETCH_DATA_FAILED",
  fetchDataFulfilled: "incentivesSummary/FETCH_DATA_FULFILLED",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: {},
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchData: {
      return { 
        ...state,
        fetching: true };
    }
    case actionTypes.fetchDataFailed: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errMsg: action.payload,
      };
    }
    case actionTypes.fetchDataFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getData: (state) => {
    return (
      (state.partnerApp.incentivesSummary &&
        state.partnerApp.incentivesSummary.data) ||
      {}
    );
  },
  getStartDate: (state) => {
    return (
      (state.partnerApp.incentivesSummary &&
        state.partnerApp.incentivesSummary.data && state.partnerApp.incentivesSummary.data.incentiveStartDate)
    );
  },
  showLoader: (state) => {
    return state.partnerApp.incentivesSummary.fetching
  }
};

/********** ACTION_CREATORS **********/
export const actions = {
  fetchData: () => ({
    type: actionTypes.fetchData,
  }),
  fetchDataFailed: (data) => ({
    type: actionTypes.fetchDataFailed,
    payload: data,
  }),
  fetchDataFulfilled: (data) => ({
    type: actionTypes.fetchDataFulfilled,
    payload: data,
  }),
};

/********** WORKERS **********/
function* fetchDataWorker() {
    try {
      const response = yield call(
        [axios, 'get'],
        API_ENDPOINTS.INCENTIVES.SUMMARY({})
      )
      if (response.status == 200) {
        yield put({ type: actionTypes.fetchDataFulfilled, payload: response.data.result });
      }
    } catch (err) {
      const errMsg = (err && err.message) || "Something went wrong";
      yield put({ type: actionTypes.fetchDataFailed, payload: errMsg });
    }
  }

/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.fetchData, fetchDataWorker);
}